<template>

  <h1>Fixing driver chat......</h1>
</template>

<script>
import axios from 'axios'

export default {
  name: "FixDriverChat",
  methods: {
    async fix495DriverChat () {
      /*
            let drivers = [
              496, 497, 498, 499, 500, 501, 502, 503, 504, 505, 506, 507
            ];
      */
      /*
            let drivers = [
              508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522
            ];
      */
      let drivers = [
        590, 591,592
      ];
      for (let i = 0; i < drivers.length ; i++) {
        var url = `${this.$store.state.apiUrl}/driver/add_conversation_participant/${drivers[i]}`
      
        try {
          let response = await axios.get(url, {
            params: {},
          })
          console.log(drivers[i] + " chat fix", response)
        } catch (e) {
          console.log(e)
        }
      }
    },
    async deleteChatChannels () {
      /*
            let drivers = [
              496, 497, 498, 499, 500, 501, 502, 503, 504, 505, 506, 507
            ];
      */
      /*
            let drivers = [
              508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519, 520, 521, 522
            ];
      */
      let drivers = [
        'CH415d3f9bd708467c947e9bb4ea342935', 'CH265ea48c872041a68a69f3595b2ca621','CHa0f6893397d247449178ac1e6b048ba1'
      ];
      for (let i = 0; i < drivers.length ; i++) {
        var url = `${this.$store.state.apiUrl}/driver/delete_chat_channel?channel_id=${drivers[i]}`
      
        try {
          let response = await axios.get(url, {
            params: {},
          })
          console.log(drivers[i] + " chat fix", response)
        } catch (e) {
          console.log(e)
        }
      }
    },
  },
  mounted() {
    this.$snackbar.success("Fixing drivers chat")
    // this.fix495DriverChat();
    // this.deleteChatChannels()
  }
  
}
</script>

<style scoped>

</style>